import { FunctionComponent, memo } from "react";
import { SelectField } from "@edgetier/select";
import { IProps } from "./select-tag-groups.types";
import { ITagGroup } from "@edgetier/watchtower-types";
import useTagGroups from "hooks-for/tag-groups/use-tag-groups";
import AddTagGroupMenu from "./add-tag-group-menu";
import "./select-tag-groups.scss";

/**
 * Select one or more tag groups for filtering.
 * @param props.hasAddItemMenu Boolean flag to display add item button.
 * @param props.name Field name.
 */
const SelectTagGroups: FunctionComponent<IProps> = ({
    name,
    hasAddItemMenu = true,
    tagGroupType,
    selectTagGroups,
    ...selectProps
}) => {
    const { data: tagGroups, isLoading } = useTagGroups({ tagGroupType }, { select: selectTagGroups });

    return (
        <SelectField<ITagGroup>
            addItemMenu={hasAddItemMenu ? <AddTagGroupMenu /> : undefined}
            description="tag group"
            getLabel={({ tagGroup }) => tagGroup}
            getValue={({ tagGroupId }) => tagGroupId}
            items={tagGroups ?? []}
            name={name}
            isLoading={isLoading}
            {...selectProps}
        />
    );
};

export default memo(SelectTagGroups);
